import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { Revision } from 'types'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'

interface Props {
  articleKey: string
  layerId: string
  id: string
}

export interface Data {
  revision: Revision
}

export enum RevisionAcceptAction {
  InsertBelow = 'insert_below',
  ReplaceSelection = 'replace_selection',
}

export interface Variables {
  accept_action: RevisionAcceptAction
}

export type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

export const acceptAIRevision = async ({ articleKey, layerId, id, ...variables }: Variables & Props) => {
  const response = await sendToApi<Data>(`/articles/${articleKey}/layers/${layerId}/ai_revisions/${id}/accept`, {
    method: 'POST',
    body: {
      ...variables,
    },
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }

  return response
}

export const useAcceptRevision = (props: Props, options?: Options) => {
  return useMutation<Data, unknown, Variables>(
    'acceptRevision',
    async (variables) => {
      const response = await acceptAIRevision({ ...props, ...variables })
      return response.data
    },
    {
      ...options,
    },
  )
}
